/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75538ResListItem {
  
  /** 任务名称 */
  taskName?: string;
  
  /** 任务活动 */
  taskActivity?: string;
  
  /** 任务负责人 */
  taskOwner?: string;
  
  /** 任务序号 */
  taskNum?: string;
  
};
    
  



export interface API75538Req {
  
  /** (String) */
  fileUrl?: string;
    
};



export interface API75538Res {
  /** TaskExcelImportForm  */
  list?: IAPI75538ResListItem[];
  
};


// 接口函数 75538 文件上传

export interface IUseGetAPI75538Return {
  /** 文件上传: 接口请求状态 */
  isAPI75538Loading: boolean;
  /** 文件上传: 接口请求返回数据 */
  dataAPI75538: API75538Res;
  /**  文件上传: 接口数据请求方法 */
  fetchAPI75538Data: (inputs: API75538Req, config?: YWRequestConfig) => Promise<API75538Res>;
  /** 文件上传: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI75538 = ():IUseGetAPI75538Return => {
  let isMount = true;
  const [isAPI75538Loading, setIsAPI75538Loading] = useState(false);
  const [dataAPI75538, setDataAPI75538] = useState<API75538Res>({} as API75538Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/import`;

  const fetchAPI75538Data = async (inputs: API75538Req, config?: YWRequestConfig): Promise<API75538Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75538Req>) || {}) as API75538Req;
    
  
    if ( isMount ) {
      setIsAPI75538Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API75538Res>(`${basePath}/yoaichat-web/chat/task/model/import?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI75538(res || {} as API75538Res);
        setIsAPI75538Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75538Loading(false);
      }
      return false as unknown as API75538Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75538Loading,
    dataAPI75538,
    fetchAPI75538Data,
    requestUrl,
  }
}

